import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=71e8d06c&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=71e8d06c&scoped=true&lang=css&"
import style1 from "./Register.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Register.vue?vue&type=style&index=2&id=71e8d06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e8d06c",
  null
  
)

export default component.exports